import { resourceQueryKeys } from '../queries/resourceQueryKeys.js';
import { resourceDetailsQueryKeys } from '../../resource-detail/queries/resourceDetailsQueryKeys.js';

const isResourceDetailQueryKey = (queryKey) => {
  return Array.isArray(queryKey) && queryKey.length > 0 && resourceQueryKeys.resourceDetail()[0] === queryKey[0] && queryKey[1] !== void 0 && typeof queryKey[1] === "string";
};
const isResourceListQueryKey = (queryKey) => {
  return Array.isArray(queryKey) && queryKey.length > 0 && resourceQueryKeys.resourceList()[0] === queryKey[0];
};
const isResourceListContextSearchQueryKey = (queryKey) => {
  return Array.isArray(queryKey) && queryKey.length > 0 && resourceQueryKeys.resourceContextSearchList()[0] === queryKey[0];
};
const isResourceAssetsQueryKey = (queryKey) => {
  return Array.isArray(queryKey) && queryKey.length > 0 && resourceDetailsQueryKeys.assets()[0] === queryKey[0] && queryKey[1] !== void 0 && queryKey[1] !== null && typeof queryKey[1] === "string";
};

export { isResourceAssetsQueryKey, isResourceDetailQueryKey, isResourceListContextSearchQueryKey, isResourceListQueryKey };
//# sourceMappingURL=queryKeyGuards.js.map
